export const GENERIC_ERROR_MESSAGE =
    'Something went wrong. Our technical team has been notified and someone will reach out to you soon with a fix.';
